import { MAIL } from './config'

/**
 * Team notification without a server of our own.
 *
 * Until the Next.js routes exist there is nowhere to hold a Resend key, so team
 * notifications go through FormSubmit, a relay that accepts a browser POST and
 * emails the fields to a fixed inbox. It needs no key. The very first
 * submission sends an activation email to MAIL.inbox; nothing is delivered until
 * someone clicks "Activate" in that email.
 *
 * Once the server routes are live, the route sends this notification through
 * Resend and this relay is no longer called.
 */

const RELAY = `https://formsubmit.co/ajax/${MAIL.inbox}`

export async function notifyTeam(
  subject: string,
  fields: Record<string, string | number | undefined>,
): Promise<{ ok: boolean; error?: string }> {
  const body: Record<string, string> = {
    _subject: subject,
    _template: 'table',
    _captcha: 'false',
  }
  for (const [key, value] of Object.entries(fields)) {
    if (value !== undefined && value !== '') body[key] = String(value)
  }

  try {
    const response = await fetch(RELAY, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
    const result = (await response.json().catch(() => null)) as { success?: string | boolean; message?: string } | null
    const ok = response.ok && (result?.success === true || result?.success === 'true')
    if (!ok) {
      // eslint-disable-next-line no-console
      console.warn('[team notification not delivered]', result?.message ?? response.status)
      return { ok: false, error: result?.message }
    }
    return { ok: true }
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[team notification failed]', error)
    return { ok: false, error: 'network' }
  }
}
